import actionTypePrefixes from "../../actions/actionTypePrefixes"

const initialState = {
  isLoading: true,
  loadingFailed: false,
  widgets: {
    performanceComparisonChart: {
      data: null,
      subtitle: null,
    },
    engagementScoreLine: {
      data: null,
      subtitle: null,
    },
    engagementScoreDoughnut: {
      data: null,
      subtitle: null,
    },
    nineBoxGridSummary: {
      data: null,
      subtitle: null,
    },
    nineBoxGridDrilldown: {
      data: null,
      subtitle: null,
    },
    riskOfLeaving: {
      data: null,
      subtitle: null,
      sampleSize: null,
    },
    challengesFaced: {
      data: null,
      subtitle: null,
    },
    employeeNetPromotorScore: {
      data: null,
      subtitle: null,
    },
    top5LD: {
      data: null,
      subtitle: null,
    },
    pulseCheckResponses: {
      data: null,
      subtitle: null,
    },
    doingWell: {
      data: null,
      subtitle: null,
    },
    needsImproving: {
      data: null,
      subtitle: null,
    },
    journeyResponses: {
      data: null,
      subtitle: null,
    },
  },
}

export default function peopleBalanceSheetReducer(state = initialState, action) {
  if (action.type.indexOf(actionTypePrefixes.PeopleBalanceSheet) !== 0) {
    return state
  }

  const actionType = action.type.replace(actionTypePrefixes.PeopleBalanceSheet, "")

  switch (actionType) {
    case "LOAD_9BG_DRILLDOWN_BOX":
      return {
        ...state,
        widgets: {
          ...state.widgets,
          nineBoxGridDrilldown: { data: null, subtitle: null },
        },
      }
    case "LOAD_9BG_DRILLDOWN_BOX_FAIL":
      return state
    case "LOAD_9BG_DRILLDOWN_BOX_SUCCESS":
      return {
        ...state,
        widgets: {
          ...state.widgets,
          nineBoxGridDrilldown: action.payload.data,
        },
      }
    case "LOAD_9BG_DRILLDOWN":
      return state
    case "LOAD_9BG_DRILLDOWN_FAIL":
      return state
    case "LOAD_9BG_DRILLDOWN_SUCCESS":
      return {
        ...state,
        widgets: {
          ...state.widgets,
          nineBoxGridDrilldown: action.payload.data,
        },
      }
    case "LOAD_DASHBOARD_DATA":
      return {
        ...state,
        errorMessageKey: null,
        isLoading: true,
        loadingFailed: false,
        widgets: {
          performanceComparisonChart: {
            data: null,
            subtitle: null,
          },
          engagementScoreLine: {
            data: null,
            subtitle: null,
          },
          engagementScoreDoughnut: {
            data: null,
            subtitle: null,
          },
          nineBoxGridSummary: {
            data: null,
            subtitle: null,
          },
          nineBoxGridDrilldown: {
            data: null,
            subtitle: null,
          },
          riskOfLeaving: {
            data: null,
            subtitle: null,
            sampleSize: null,
          },
          challengesFaced: {
            data: null,
            subtitle: null,
          },
          employeeNetPromotorScore: {
            data: null,
            subtitle: null,
          },
          top5LD: {
            data: null,
            subtitle: null,
          },
          pulseCheckResponses: {
            data: null,
            subtitle: null,
          },
          doingWell: {
            data: null,
            subtitle: null,
          },
          needsImproving: {
            data: null,
            subtitle: null,
          },
          journeyResponses: {
            data: null,
            subtitle: null,
          },
        },
      }

    case "LOAD_DASHBOARD_DATA_SUCCESS":
      return {
        ...state,
        errorMessageKey: null,
        isLoading: false,
        loadingFailed: false,
        widgets: {
          ...state.widgets,
          performanceComparisonChart: action.payload.data.performanceComparisonChart,
          engagementScoreLine: action.payload.data.engagementScoreLine,
          engagementScoreDoughnut: action.payload.data.engagementScoreDoughnut,
          nineBoxGridSummary: action.payload.data.nineBoxGrid,
          nineBoxGridDrilldown: {
            data: null,
          },
          pulseCheckResponses: action.payload.data.pulseChecks,
          riskOfLeaving: action.payload.data.riskOfLeaving,
          challengesFaced: action.payload.data.challengesFaced,
          employeeNetPromotorScore: action.payload.data.employeeNetPromoterScore,
          top5LD: action.payload.data.learningAndDevelopment,
          doingWell: action.payload.data.doingWell,
          needsImproving: action.payload.data.needsImproving,
          journeyResponses: action.payload.data.journeys,
        },
      }

    case "LOAD_DASHBOARD_DATA_FAIL":
      return {
        ...state,
        errorMessageKey: "Dashboards.ErrorMessages.ApiError",
        isLoading: false,
        loadingFailed: true,
        widgets: {
          ...state.widgets,
          performanceComparisonChart: { data: null, subtitle: null },
          engagementScoreLine: { data: null, subtitle: null },
          engagementScoreDoughnut: { data: null, subtitle: null },
          nineBoxGridSummary: { data: null, subtitle: null },
          nineBoxGridDrilldown: { data: null, subtitle: null },
          riskOfLeaving: { data: null, subtitle: null, sampleSize: null },
          challengesFaced: { data: null, subtitle: null },
          employeeNetPromotorScore: { data: null, subtitle: null },
          pulseCheckResponses: { data: null, subtitle: null },
          journeyResponses: { data: null, subtitle: null },
        },
      }
    case "COMPARISON_LINE_CHART_LOAD_COMPARISON_TYPE_SUCCESS":
      return {
        ...state,
        widgets: {
          ...state.widgets,
          performanceComparisonChart: action.payload.data,
        },
      }
    case "COMPARISON_LINE_CHART_LOAD_COMPARISON_TYPE_FAIL": {
      // TODO: Change this to pop up window component
      alert("Comparison fail!")
      break
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/dashboards/peopleBalanceSheetReducer.js